<template>
<span
    v-if="item != null && col != null"
>
    <v-chip
        v-for="(period, index) in item[col]"
        :key="index"
        v-on:click="onClickCell"
    >
        {{period}}
    </v-chip>

    <v-chip
        v-if="item[col] != null && item[col].length == 0"
        v-on:click="onClickCell"
    >
        Closed
    </v-chip>
</span>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: function() { return null; }
        },

        col: {
            type: String,
            default: function() { return null; }
        },
    },

    methods: {
        onClickCell(item) {
            this.$emit('click', this.item, this.col)
        }
    },
}
</script>

<style lang="scss" scoped>

</style>